import { render, staticRenderFns } from "./DetailsIcon.vue?vue&type=template&id=af759d02&scoped=true"
import script from "./DetailsIcon.vue?vue&type=script&lang=js"
export * from "./DetailsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af759d02",
  null
  
)

export default component.exports